export function fmt_amount(n: number) {
	return n.toFixed(2);
}

export function fmt_reknr(reknr: string) {
	if (reknr && reknr.length === 18)
		return [
			reknr.substring(0, 4),
			reknr.substring(4, 8),
			reknr.substring(8, 12),
			reknr.substring(12, 16),
			reknr.substring(16)
		].join(' ');
	else return reknr;
}
